module.exports = __webpack_public_path__ + "6b4f005f25142fb82b12175b17e26e4a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-girl-brown.png
// module id = 2687
// module chunks = 0